// removed by extract-text-webpack-plugin
module.exports = {"blogHead":"_1hE1yw84ZdgueL5Ho8-zU1","splash":"_2s1Ed9ZINSgs0xhZ5z0ki7"};


/*****************
 ** WEBPACK FOOTER
 ** ../components/BlogHead.module.scss
 ** module id = 1188
 ** module chunks = 0
 **/